<template>
  <div class="vertical-center">
    <div v-if="this.params.value !== null">
      <vs-button :disabled="isDisabled" class="float-left mr-2" @click="getConfig" type="filled" color="primary" size="small">Get Configs</vs-button>
    </div>
    <div v-else>
      <vs-button disabled class="float-left mr-2" @click="getConfig" type="filled" color="primary" size="small">Get Configs</vs-button>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import VueQrcode from 'vue-qrcode';
  
  export default Vue.extend({
    name: 'DeviceRequestGetConfig',
    components: { VueQrcode },
    data() {
      return {
        value: '',
        popupActive:false,
        camera: 'off',
        result: null,
        isDisabled: false,
        showScanConfirmation: false,
      }
    },
    methods: {
      getConfig(){
        if(!this.params.data.config.user){
          let hexstring = parseInt(Date.parse(this.params.data.created_at), 10).toString(16);
          let qrconfig = "AINO#0#" + this.params.data.serial_number + `#` + hexstring + "#" + this.params.data.enc
          let payload = {
            index : this.params.data.id,
            data : this.params.data,
            code : this.params.data.code,
            value : qrconfig
          }
          this.$root.$emit("get-config-DeviceRequestGetConfig", payload)
        }else{
          const regex = /\/$/i;
          let baseURL = process.env.VUE_APP_SVD_API_URL
          baseURL = baseURL.replace(regex, '')
          let login_url = baseURL + "/api/v1/auth/login"
          let provision_url = baseURL + "/api/v1/devices/provision"
          let qrconfig = "AINO#0#" + this.params.data.serial_number + `#{"login_url":"`+login_url+`","provision_url":"`+provision_url+`","email":"` + this.params.data.config.user.email + `","password":"` + this.params.data.config.user.password + `","code":"` + this.params.data.code + `", "serial_number":"` + this.params.data.serial_number + `"}`
          let payload = {
            index : this.params.data.id,
            data : this.params.data,
            code : this.params.data.code,
            value : qrconfig
          }
          this.$root.$emit("get-config-DeviceRequestGetConfig", payload)
        }
      }
    },
    mounted() {
      if (this.params.data.status_provision == 'provisioned') this.isDisabled = true
    }
  })
</script>

<style scoped>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
</style>

